import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { getQueryParams } from "@ploy-lib/commission-api";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { Box, Paper, Grid, CircularProgress, Checkbox, Typography, Button, FormControl } from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import { TableStructure } from "./TableStructure";
import { DployAutocomplete } from "@ploy-ui/form-fields";
import { ProcessLog } from "./ProcessLog";
export const Commission = ({ getCommission, vendorSearch, underwriterSearch, sendToApproval, getAdditionalInformation, getApplicationInformation, updateStatus, internalUser }) => {
    const [tab, setTab] = React.useState("marked-as-paid");
    const [searchInGroup, setSearchInGroup] = React.useState(true);
    const [loading, setLoading] = React.useState(false);
    const [commissions, setCommissions] = React.useState([]);
    const [vendor, setVendor] = React.useState();
    const [underwriter, setUnderwriter] = React.useState();
    const getYearsAgo = (yearsAgo = 0) => {
        const today = new Date();
        if (yearsAgo === 0) {
            return today;
        }
        return new Date(today.getFullYear() - yearsAgo, 0, 1);
    };
    const [fromDate, setFromDate] = React.useState(getYearsAgo(5).toISOString());
    const [toDate, setToDate] = React.useState(getYearsAgo(0).toISOString());
    const handleChangeTab = (event, newValue) => {
        setTab(newValue);
        handleGetCommission(undefined, newValue);
    };
    const handleVendorChange = (e, newVendor) => {
        setVendor(newVendor);
        handleGetCommission(newVendor);
    };
    const handleUnderwriterChange = (e, newUnderwriter) => {
        setUnderwriter(newUnderwriter);
        handleGetCommission();
    };
    const handleChangeSearchInGroup = (newValue) => {
        setSearchInGroup(newValue);
        handleGetCommission();
    };
    const handleGetAdditionalInformation = (monthYear, agreementNumber) => {
        return (!internalUser &&
            getAdditionalInformation(monthYear, agreementNumber, searchInGroup));
    };
    const handleUpdateStatus = async (agreement) => {
        var response = await updateStatus(agreement);
        return response;
    };
    const handleGetCommission = async (newVendor, type) => {
        if (internalUser &&
            !vendor &&
            !newVendor &&
            ((tab === "marked-as-paid" && type === undefined) ||
                type === "marked-as-paid")) {
            setCommissions([]);
            return;
        }
        setLoading(true);
        const [orgNo = "", backOfficeId = ""] = vendor
            ? vendor.Value.split("|")
            : newVendor
                ? newVendor.Value.split("|")
                : [];
        const searchParams = {
            type: type ? type : tab,
            vendorNumber: orgNo,
            vendorId: backOfficeId,
            fromDate: "", //getYearsAgo(5).toISOString(),
            toDate: getYearsAgo(0).toISOString(),
            userId: "",
            searchInGroup,
            agreementNumber: ""
        };
        var response = await getCommission(searchParams);
        if (response && response.success) {
            setCommissions(response.commissions);
        }
        setLoading(false);
    };
    React.useEffect(() => {
        handleGetCommission(undefined, "marked-as-paid");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const downloadParamters = {
        type: tab,
        vendorNumber: vendor ? vendor.Value.split("|")[0] : "",
        vendorId: vendor ? vendor.Value.split("|")[1] : "",
        fromDate: fromDate,
        toDate: toDate,
        userId: underwriter ? underwriter.Value : "",
        searchInGroup,
        agreementNumber: ""
    };
    return (_jsxs(Grid, { container: true, spacing: 2, children: [internalUser && (_jsx(Grid, { item: true, xs: 12, children: _jsx(Paper, { children: _jsxs(Grid, { container: true, xs: 12, children: [_jsx(Grid, { item: true, xs: 6, children: _jsx(Box, { p: 2, children: _jsx(DployAutocomplete, { value: vendor ?? null, onChange: handleVendorChange, getItemSuggestions: vendorSearch, minSearch: 3, items: [], getItemLabel: item => item.Key, label: "Forhandler", variant: "outlined", margin: "normal", helperText: " " }) }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(Box, { p: 2, children: _jsx(DployAutocomplete, { value: underwriter ?? null, onChange: handleUnderwriterChange, getItemSuggestions: underwriterSearch, minSearch: 3, items: [], getItemLabel: item => item.Key, label: "Saksbehandler", variant: "outlined", margin: "normal", helperText: " " }) }) })] }) }) })), vendor && (_jsxs(Grid, { item: true, xs: 12, children: [_jsx(Box, { p: 1, display: "inline-block", children: _jsx(DatePicker, { views: ["year", "month"], label: "Fra", value: fromDate, onChange: val => setFromDate(val ? val.toString() : "") }) }), _jsx(Box, { p: 1, display: "inline-block", children: _jsx(DatePicker, { views: ["year", "month"], label: "Til", value: toDate, onChange: val => setToDate(val ? val.toString() : "") }) }), _jsx(Box, { p: 1, display: "inline-block", children: _jsx(FormControl, { variant: "standard", children: _jsx(Button, { color: "primary", variant: "outlined", endIcon: _jsx(CloudDownloadIcon, {}), href: `/api/backoffice-commission/download?${getQueryParams(downloadParamters)}`, children: "Last ned" }) }) })] })), _jsx(Grid, { item: true, xs: 12, children: _jsxs(Paper, { children: [_jsxs(Tabs, { value: tab, onChange: handleChangeTab, children: [_jsx(Tab, { label: "Utbetalt", value: "marked-as-paid" }), _jsx(Tab, { label: "Opptjent", value: "earned" }), internalUser && (_jsx(Tab, { label: "Ikke behandlede avregninger", value: "not-processed" })), internalUser && (_jsx(Tab, { label: "Godkjente avregninger", value: "approved" }))] }), _jsxs(Box, { p: 1, children: [_jsx(Controls, { searchInGroup: searchInGroup, setSearchInGroup: handleChangeSearchInGroup }), _jsx(VisibleTab, { tab: tab, commissions: commissions, loading: loading, getAdditionalInformation: handleGetAdditionalInformation, sendToApproval: sendToApproval, getApplicationInformation: getApplicationInformation, updateStatus: handleUpdateStatus })] })] }) })] }));
};
export const VisibleTab = ({ tab, commissions, loading, getAdditionalInformation, sendToApproval, getApplicationInformation, updateStatus }) => {
    if (loading)
        return _jsx(CircularProgress, { size: 20 });
    switch (tab) {
        case "marked-as-paid":
            return (_jsxs(_Fragment, { children: [_jsx("h1", { children: "Utbetalt" }), commissions ? (_jsx(TableStructure, { list: commissions, groupByLamda: c => c.date.getFullYear(), monthly: false, year: "0" })) : null] }));
        case "earned":
            return (_jsxs(_Fragment, { children: [_jsx("h1", { children: "Opptjent" }), commissions ? (_jsx(TableStructure, { list: commissions, groupByLamda: c => c.startDate.getFullYear(), monthly: false, year: "0", getAdditionalInformation: getAdditionalInformation, sendToApproval: sendToApproval, getApplicationInformation: getApplicationInformation })) : null] }));
        case "not-processed":
            return (_jsxs(_Fragment, { children: [_jsx("h1", { children: "Ikke behandlede avregninger" }), commissions ? (_jsx(ProcessLog, { log: commissions, updateStatus: updateStatus })) : null] }));
        case "approved":
            return (_jsxs(_Fragment, { children: [_jsx("h1", { children: "Godkjente avregninger" }), commissions ? (_jsx(ProcessLog, { log: commissions, updateStatus: updateStatus, approved: true })) : null] }));
        default:
            return _jsx("h1", { children: "Velg en fane" });
    }
};
export const Controls = ({ searchInGroup, setSearchInGroup }) => {
    return (_jsxs(_Fragment, { children: [_jsx(Typography, { component: "span", children: "Konserns\u00F8k" }), _jsx(Checkbox, { checked: searchInGroup, onChange: () => setSearchInGroup(!searchInGroup) })] }));
};
//# sourceMappingURL=Commission.js.map